import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Footer from "../componants/footer/Footer";
import FirstHeader from "../componants/header/firstheader/FirstHeader";
import Header from "../componants/header/header/Header";
import ConnectionLabelAlert from "../componants/shared/minicomponents/connectionlabelalert/ConnectionLabelAlert";
import GlobalOverlay from "../componants/shared/minicomponents/globaloverlay/GlobalOverlay";
import ScrollToTop from "../componants/shared/minicomponents/scrolltotop/ScrollToTop";
import SkipContentLink from "../componants/shared/minicomponents/SkipContentLink";
import MobileNav from "../componants/shared/mobillenav/MobileNav";
import WhatDoIDoButton from "../componants/shared/mytools/whatdoidobutton/WhatDoIDoButton";
import WhatDoIDoMenu from "../componants/shared/mytools/whatdoidomenu/WhatDoIDoMenu";
import ToastAlert from "../componants/shared/popups/ToastAlert/ToastAlert";
import ToastConfirm from "../componants/shared/popups/ToastConfirm/ToastConfirm";
import useCurrentSkipLinkId from "../hooks/App/useCurrentSkipLinkId";
import useOnlineStatus from "../hooks/Helper/useOnlineStatus";

const RoutesLayout = () => {
  const skipLinkSectionId = useCurrentSkipLinkId();
  const isWebsiteOnline = useOnlineStatus();
  const { showWhatDoIDoIcon } = useSelector((state) => state.localStorage);

  return (
    <div className="App" tabIndex="-1">
      <SkipContentLink scrollTo={skipLinkSectionId} />
      {showWhatDoIDoIcon && <WhatDoIDoButton />}
      <WhatDoIDoMenu />
      <FirstHeader />
     <Header /> 
     <MobileNav /> 
 <GlobalOverlay /> 
      <ScrollToTop />
      <Outlet />
      <Footer />
      <ConnectionLabelAlert isOnline={isWebsiteOnline} />
      <ToastAlert />
      <ToastConfirm />
    </div>
  );
};
export default RoutesLayout;
